const mapWdgtElem = document.querySelectorAll('.wt-Map_MapLayer, .wdgt-Map_Content');
const mapLayerElem = document.querySelectorAll('.wt-Map_ContentLayer');
const airportElem = document.querySelectorAll('.wt-Map .wt-Map-airport-offer, .wt-Map .inactive-airpots');

window.fireOnVisible('.wt-Map', async () => {
    await import('./assets/css/wt-Map.scss');
});

window.fireOnVisible(mapWdgtElem, async (elem) => {
    await import('./assets/css/map.scss');

    if (window.TCMS.product === 'flug') {
        await import('./assets/css/map-flug.scss');
    }
    await import('./assets/js/map_links.js');

    if (elem.querySelector('.wdgt-Tabbar')) {
        await import('../Tabbar/import.js');
    }
});

window.fireOnVisible(mapLayerElem, async () => {
    await import('./assets/css/map.scss').then(async () => {
        if (window.TCMS.product === 'flug') {
            await import('./assets/css/map-flug.scss');
        }
        if (document.querySelector('.c24-mapLayer')) {
            await import('./assets/css/swt-Map_Childlinks.scss');
        }
    });
});

window.fireOnVisible(airportElem, async () => {
    await import('./assets/css/swt-Map_airports.scss');
});

//Mietwagen
window.fireOnVisible('.wt-Map-LinkList', async (elem) => {
    if (window.TCMS.product === 'mietwagen') {
        await import('./assets/css/wt-Map-mietwagen.scss');
        await import('./assets/js/map_links.js');
    }
});
